import { render, staticRenderFns } from "./ChatToggler.vue?vue&type=template&id=1810a729&"
import script from "./ChatToggler.vue?vue&type=script&lang=js&"
export * from "./ChatToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports